import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReportsService } from 'src/app/reports/reports.service';
import { environment } from 'src/environments/environment';
import { CmaState } from '../cma.state';

@Component({
  selector: 'app-property-details-card',
  templateUrl: './property-details-card.component.html',
  styleUrls: ['./property-details-card.component.scss'],
})

export class PropertyDetailsCardComponent implements OnInit, OnDestroy {
  @Input() isDisabled: boolean;
  @Output() propertyDetails = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder, public cmaState: CmaState, private cdr: ChangeDetectorRef, private reportsService: ReportsService) { }

  ngOnDestroy(): void {
    this.onDestroyNotifier$.next(null);
    this.onDestroyNotifier$.complete();
  }

  propertyTypes = [
    'Single Family Residence',
    'Condominium',
    'Mobile Home',
    'Townhouse',
    'Quadruplex',
    'Manufactured Home',
    'MultiFamily',
    'Manufactured on Land',
    'Apartment',
    'Commercial',
  ];
  listingImageBaseUrl = environment.listingImageBaseUrl;
  propertyDetailsForm: FormGroup;
  property: any;
  onDestroyNotifier$ = new Subject();
  currentYear: number = new Date().getFullYear();

  ngOnInit(): void {
    this.propertyDetailsForm = this.formBuilder.group({
      subType: null,
      livingArea: null,
      yearBuilt: null,
      beds: null,
      baths: null,
      lotSize: null,
      address: null,
      pmxPropertyId: null,
      stories: null,
      parking: null,
      monthsBack: null,
      MlsBoard: null,
      imgUrl: null
    });

    this.propertyDetails.emit(this.propertyDetailsForm.value);

    this.propertyDetailsForm.valueChanges.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.propertyDetails.emit(this.propertyDetailsForm.value);
      this.cdr.detectChanges();
    });

    this.cmaState.propertyDetailsCardInput.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res.PMXPropertyId) {

        this.reportsService.getProperty({
          pmxPropertyId: res.PMXPropertyId,
          listingId: res.ListingId,
          type: ['basic', 'listing'],
        }, 'cma');

      }

    });


    this.cmaState.propertyDetailsInput.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.property = res;
        this.propertyDetailsForm.patchValue({
          subType: res.PropertySubType ? res.PropertySubType : null,
          livingArea: res.LivingArea ? res.LivingArea : null,
          yearBuilt: res.YearBuilt ? res.YearBuilt : null,
          beds: res.BedroomsTotal ? res.BedroomsTotal : null,
          baths: res.BathroomsTotalInteger ? res.BathroomsTotalInteger : null,
          lotSize: res.LotSizeSquareFeet ? res.LotSizeSquareFeet : null,
          address: res.Address ? res.Address : null,
          pmxPropertyId: res.PMXPropertyId ? res.PMXPropertyId : null,
          stories: res.Stories ? res.Stories : null,
          parking: res.Parking ? res.Parking : null,
          monthsBack: res.MonthsBack && res.MonthsBack != '' ? res.MonthsBack : 12,
          MlsBoard: res.MlsBoard ? res.MlsBoard : null,
          imgUrl: res.imgUrl ? res.imgUrl : null
        });
        this.propertyDetails.emit(this.propertyDetailsForm.value);
        this.cdr.detectChanges();
      }
    });

  }
}